import { Button, styled, Typography } from '@mui/material';

export const AutomationTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightMedium,
  marginBottom: theme.spacing(2),
}));

export const SecondaryButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  color: theme.palette.primary.dark,
  marginTop: theme.spacing(3),
  padding: `${theme.spacing(0.75)} ${theme.spacing(2)}`,
}));
